export enum RedirectLinkEnum {
    default,
    clientList,
    error,
}